import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AccountSwitcher,
  Box,
  Stack,
  Typography,
  useTokens,
} from '@barracuda-internal/bds-core';
import NavigationPanel from './NavigationPanel';
import { actions as authActions } from 'guardian/comp/login/authReducer';

const WrapperComponent = ({ children, loading }) => {
  const tokens = useTokens();
  const dispatch = useDispatch();
  const { accounts, account: currentAccount } = useSelector(
    (state) => state.guardian.auth
  );
  const user = useSelector((state) => state.guardian.auth.user);

  if (loading) {
    return (
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Typography variant="body1">Loading…</Typography>
      </Stack>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: tokens.aliasesColorBgPageDefault,
      }}
    >
      <NavigationPanel
        email={user?.email || user?.username || ''}
        name={user?.name || user?.username || 'User'}
      />
      <Stack
        sx={{
          height: '100vh',
          flex: 1,
          minWidth: 0,
        }}
      >
        <AccountSwitcher
          accounts={accounts.map((acc) => ({ id: acc.id, name: acc.name }))}
          onSelectAccountCallback={(account) =>
            dispatch(authActions.switchAccount(account?.id))
          }
          initAccount={currentAccount?.id}
          closeText="Close"
        />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            padding: tokens.aliasesSpaceContainerSpacious,
            backgroundColor: tokens.aliasesColorBgPageDefault,
          }}
        >
          {children}
        </Box>
      </Stack>
    </Box>
  );
};

export default WrapperComponent;
